// register debouncing functions
// deBouncer(jQuery,'new eventname', 'original event', timeout);
// Note: keep the jQuery namespace in mind, don't overwrite existing functions!
const deBouncer = function ($, cf, of, interval) {
  const debounce = function (func, threshold, execAsap) {
    let timeout;
    return function debounced(...args) {
      const obj = this;
      function delayed() {
        if (!execAsap) {
          func.apply(obj, args);
        }
        timeout = null;
      }
      if (timeout) {
        clearTimeout(timeout);
      } else if (execAsap) {
        func.apply(obj, args);
      }
      timeout = setTimeout(delayed, threshold || interval);
    };
  };
  jQuery.fn[cf] = function (fn) {
    return fn ? this.bind(of, debounce(fn)) : this.trigger(cf);
  };
};
deBouncer(jQuery, 'smartresize', 'resize', 300);
deBouncer(jQuery, 'smartscroll', 'scroll', 300);
deBouncer(jQuery, 'smartmousemove', 'mousemove', 300);
deBouncer(jQuery, 'smartkeyup', 'keyup', 600);